import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import LinkButton, { LINK_BUTTON_THEMES } from 'components/LinkButton'

import * as css from './StatisticLink.module.scss'
import { LINK_TYPES } from 'components/Link'

class StatisticLink extends React.PureComponent {
    static propTypes = {
        "className": PropTypes.string,
        "id": PropTypes.number.isRequired,
        "title": PropTypes.string.isRequired,
        "size": PropTypes.string.isRequired,
        "filetype": PropTypes.string.isRequired,
        "url": PropTypes.string.isRequired,
        "hasAccess": PropTypes.bool.isRequired,
        "isLoggedIn": PropTypes.bool.isRequired,
    }

    render() {
        const {
            className,
            url,
            title,
            size,
            filetype,
            hasAccess,
        } = this.props

        const linkDetails = size && filetype ? `(${size} / ${filetype})` 
            : size ? `(${size})` 
                : filetype ? `(${filetype})` 
                    : ''

        return (
            <LinkButton 
                url={url}
                type={hasAccess ? LINK_TYPES.download : LINK_TYPES.restricted}
                text={`${title} ${linkDetails}`}
                theme={LINK_BUTTON_THEMES.outline}
                className={cn(className, css.report)}
            />
        )
    }
}

export default StatisticLink
